import { cutChainName, imageChain } from 'constant/payment';
import _, { filter } from 'lodash';
import { useQuery } from 'react-query';
import { TNetwork } from 'types/fees';
import { IChain } from 'types/network';
import axiosServices from 'utils/axios';

const useChain = ({
    enableChainList = false,
    symbol,
    enableFilterNetwork = false
}: {
    enableChainList?: boolean;
    symbol?: string;
    enableFilterNetwork?: boolean;
}) => {
    const qGetChainList = useQuery(['qGetChainList'], () => axiosServices.get(`/v1/public/getChains`), {
        enabled: enableChainList
    });

    const filterListChainBySymbol = (networkIdList: TNetwork[], dataChainList: IChain[]) => {
        const arrayNetworkId = _.map(networkIdList, (c: TNetwork) => c.networkId);
        const networkAvailable = _.filter(dataChainList, (chain: IChain) => _.includes(arrayNetworkId, chain.chainId));
        return _.map(networkAvailable, (dataChain: IChain) => {
            return { ...dataChain, image: imageChain(dataChain.chainId), networkShortName: cutChainName(dataChain.chainName) };
        });
    };

    const qGetChainSelectedListBySymbol = useQuery(
        [`qGetChainSelectedListBySymbol_${symbol}`, symbol],
        () => axiosServices.get(`v1/wallet/getChainSelectedListBySymbol/${symbol}`),
        {
            enabled: Boolean(enableFilterNetwork && symbol)
        }
    );

    return {
        qGetChainList,
        dataChainList: filter(qGetChainList?.data?.data, (t) => t.enabled).map((v) => v) as IChain[],
        filterListChainBySymbol,
        qGetChainSelectedListBySymbol,
        dataChainSelectedListBySymbol: qGetChainSelectedListBySymbol?.data?.data as TNetwork[]
    };
};

export default useChain;
